"use client";

import { memo } from "react";
import { titleCasePreserveAcronyms } from "@/lib/string/title-case";
import { CompanyLogo } from "../logo/company-logo";
import { EmptyCell } from "./empty";
import type { CandidateCellRow } from "./row";

export const CompanyCell = memo(
  function CompanyCell({ row }: { row: CandidateCellRow }) {
    const name = row.companyName?.trim();
    if (!name) return <EmptyCell />;
    return (
      <div className="flex min-w-0 items-center gap-1.5">
        <CompanyLogo domain={row.companyDomain} name={name} />
        <span className="truncate whitespace-nowrap text-sm font-medium text-heading">
          {titleCasePreserveAcronyms(name)}
        </span>
      </div>
    );
  },
  (prev, next) =>
    prev.row.companyName === next.row.companyName &&
    prev.row.companyDomain === next.row.companyDomain,
);
